<template>
  <BModal :id="id" :visible="show" scrollable size="lg" @hide="$emit('hide')">
    <template #modal-header>
      <h5 class="mb-3 mt-auto ml-auto mr-auto modal-title">Terms And Conditions</h5>
      <button type="button" class="modal-close" aria-label="Close" @click="$emit('hide')">
        <i class="fa fa-times-thin" style="font-size: 1.5em" />
      </button>
    </template>
    <div v-if="terms" class="mx-3">
      <h5>Standard Terms</h5>
      <span style="white-space: pre-line">{{ terms }}</span>
    </div>
    <div v-if="preOrderTerms">
      <div v-if="terms" class="sep-large sep-light" />
      <div class="mx-3">
        <h5>Preorder Terms</h5>
        <span style="white-space: pre-line">{{ preOrderTerms }}</span>
      </div>
    </div>
    <template #modal-footer>
      <BushelBtn variant="secondary" ripple-color="secondary" flat @click="$emit('hide')"> Close </BushelBtn>
    </template>
  </BModal>
</template>

<script>
export default {
  components: {},
  props: {
    show: { type: Boolean, required: true },
    id: { type: String, default: "termsAndConditionsModal" },
    terms: { type: String },
    preOrderTerms: { type: String },
  },
  emits: ["hide"],
  data() {
    return {};
  },
  computed: {},
  mounted() {},
};
</script>
